var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 62626",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.023,
    height: 33.237,
    viewBox: "0 0 33.023 33.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "70s8qnibga",
    cx: 0.47,
    cy: 0.726,
    r: 0.653,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34ff6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#31d556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31c24e"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13061"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13060"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9223",
    d: "M3154.324 4523.118a16.512 16.512 0 1 1-16.512-16.618 16.325 16.325 0 0 1 10.258 3.606 16.607 16.607 0 0 1 6.254 13.012z",
    transform: "translate(-3121.3 -4506.5)",
    style: {
      fill: "url(#70s8qnibga)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13064"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13062",
    transform: "translate(19.955 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 168",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13063",
    transform: "translate(8.713 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 169",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13065"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9224",
    d: "M23.538 21.569a4.656 4.656 0 0 1-.843 2.121 6.208 6.208 0 0 1-1.757 1.556 8.424 8.424 0 0 1-4.5 1.2 9.118 9.118 0 0 1-4.5-1.2 6.214 6.214 0 0 1-1.757-1.556 4 4 0 0 1-.843-2.121.069.069 0 0 1 .071-.071h.071a6.66 6.66 0 0 0 2.037.989c.632.142 1.195.283 1.757.354 1.125.142 2.179.142 3.233.212a25.513 25.513 0 0 0 3.232-.212 8.536 8.536 0 0 0 1.756-.354 5.336 5.336 0 0 0 2.038-.989c-.071 0 0 0 0 .071z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.30761e73ae1555df4670b3c434c6de87.svg";
export { ForwardRef as ReactComponent };